import Button from '@/shared/components/Button';
import {Box, Typography} from '@mui/material';
import {forgotPasswordModalStyles} from './ForgotPasswordStyle.styles';
import {H5, IMAGE_TABLE_ALT} from '@/utils/constants';
import DangerIcon from '@icons/danger.svg';

interface ForgotPasswordStep1Props {
	onCloseModal: () => void;
	handleSubmit: () => void;
	userEmail: string;
}
const ForgotPasswordStep3 = ({onCloseModal, handleSubmit, userEmail}: ForgotPasswordStep1Props) => {
	return (
		<Box sx={forgotPasswordModalStyles.content}>
			<Box sx={forgotPasswordModalStyles.iconWrap}>
				<img src={DangerIcon} alt={IMAGE_TABLE_ALT} />
			</Box>
			<Box sx={forgotPasswordModalStyles.contentWrap}>
				<Typography variant={H5} sx={forgotPasswordModalStyles.title}>
					Oops
				</Typography>
				<Typography sx={forgotPasswordModalStyles.description}>There is no account associated with:</Typography>
				<Typography sx={forgotPasswordModalStyles.afterDescription}>{userEmail}</Typography>
			</Box>
			<Box sx={forgotPasswordModalStyles.btnWrap}>
				<Button sx={forgotPasswordModalStyles.btn} title="Try Again" onClick={handleSubmit} />
			</Box>
		</Box>
	);
};

export default ForgotPasswordStep3;
